/**
 * Substitutes `{placeholder}` tokens in a template string against a context object.
 * Used for task `display_name`, `instructions`, and `submit_action.url`, where the
 * template defines the pattern and the instance context provides the values.
 *
 * Missing/nullish/non-primitive values render as an empty string — preferable to
 * leaking `{key}` literals or `[object Object]` to end users.
 *
 * @example
 *   interpolate('Upload your {document_type_id}', { document_type_id: 'W-9' })
 *   // → "Upload your W-9"
 *
 * @example
 *   interpolate('Due in {days} days', {})
 *   // → "Due in  days"
 */
export default function interpolate(template: string, context: Record<string, unknown>): string {
    return template.replace(/\{(\w+)\}/g, (_, key) => {
        const value = context[key];
        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
            return String(value);
        }
        return '';
    });
}
